/**
 * Detects if the current route is a blog route
 * This is a safe fallback that returns false by default
 * Route detection should be passed explicitly to components
 */
export function isBlogRoute(): boolean {
  // Always return false as fallback to ensure full components are loaded
  // This prevents build errors and ensures compatibility
  return false;
}

/**
 * Client-side blog route detection using window.location
 * Only use this in client components after hydration
 */
export function isBlogRouteClient(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.location.pathname.startsWith('/blog');
}
